import { CheckIcon } from '@cash-me/react-components'
import styled from 'styled-components'

import { theme } from 'styles/theme'

const { media, space, radii } = theme

export const Video = styled.div`
  position: relative;
  margin-bottom: ${space['spacing-lg']};
  border-radius: ${radii['corner-radius-md']};
  overflow: hidden;

  @media (${media.tablet}) {
    margin-right: ${space['spacing-lg']};
  }
`

export const Polygons = styled.div`
  position: absolute;
  top: 2rem;
  left: -15rem;
  display: none;

  .filled-polygon, .stroke-polygon {
    position: absolute;
    width: 800px;
    height: 800px;
  }
  
  .stroke-polygon {
    left: 6rem;
  }

  @media (${media.desktop}) {
    display: block;
  }
`

export const LoanInfos = styled.ul`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${space['spacing-md']};
  margin-bottom: ${space['spacing-xl']};

  @media (${media.tablet}) {
    gap: ${space['spacing-sm']};
  }

  @media (${media.desktop}) {
    gap: ${space['spacing-md']};
  }
`

export const LoanInfosItem = styled.li`
  display: flex;
  align-items: center;
  gap: ${space['spacing-sm']};
`

export const LoanInfosIcon = styled(CheckIcon)`
  margin-bottom: ${space['spacing-xxs']};

  @media (${media.tablet}) {
    margin-bottom: 0;
  }
`
